
































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";

export enum ReservationLinksEnum {
  SelfCheckIn = 1,
  Confirmation = 2,
}

@Component({
  components: {
    LoadingOverlay,
  },
})
export default class ReservationLinksModal extends Vue {
  @PropSync("open") isOpen?: boolean;
  @Prop() type?: ReservationLinksEnum;
  @Prop() title?: string;
  @Prop() reservationId?: number;

  links: string[] = [];
  isLoading = false;

  copyLink(link: string) {
    navigator.clipboard.writeText(link);

    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  @Watch("isOpen")
  openWatch(fresh: boolean) {
    if (fresh) {
      this.loadLinks();
    } else {
      this.links = [];
    }
  }

  loadLinks() {
    if (!this.reservationId) {
      this.links = [];
      this.isLoading = false;
      return;
    }

    const linkEndpoint =
      this.type === ReservationLinksEnum.SelfCheckIn
        ? "GetSelfCheckInLink"
        : "GetConfirmationLink";

    this.isLoading = true;
    Vue.axios
      .get<string[]>("/reservations/" + linkEndpoint, {
        params: {
          reservationId: this.reservationId,
        },
      })
      .then((res) => {
        this.links = res.data;
        if (this.links.length === 1) this.copyLink(this.links[0]);
      })
      .finally(() => (this.isLoading = false));
  }
}
